import React, { Component } from "react";
import "./SamplePassport.scss";
import VoterIDFront from "../../../assets/docSampleImages/Passport Front.jpg";
import VoterIDBack from "../../../assets/docSampleImages/Passport Back.jpg";
import { useDialogA11y } from "../../UI/Backdrop/Backdrop";
export interface IViewSamplePassportPopup {
  setShowPopup: Function;
  showPopup: boolean;
  text?: any;
  children?: any;
  parentClassName?: string;
}
const SamplePassportPopup = (props: IViewSamplePassportPopup) => {
  const closePopup = () => {
    if (props?.setShowPopup !== undefined) props.setShowPopup(false);
  };
  const dialogRef = useDialogA11y(!!props.showPopup, closePopup);
  const overlayRef = React.useRef<HTMLDivElement>(null);
  React.useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (overlayRef.current && event.target === overlayRef.current) {
        closePopup();
      }
    };

    const timer = setTimeout(() => {
      document.addEventListener("mousedown", handleClickOutside);
    }, 0);

    return () => {
      clearTimeout(timer);
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [props?.setShowPopup]);

  return (
    <div
      className={`overlay-Passport ${props?.parentClassName ?? ""}`}
      ref={overlayRef}
    >
      <div className="popup-Passport" role="dialog" aria-modal="true" aria-labelledby="sample-passport-popup-title" ref={dialogRef}>
        {/* Close Button */}
        <button
          type="button"
          className="close-btn"
          aria-label="Close"
          onClick={closePopup}
        >
          <i className="edel-icon-close" aria-hidden="true" />
        </button>

        <h2 className="popup-title" id="sample-passport-popup-title">Uploading Passport</h2>

        {/* Popup Content */}
        {/* {commonUIView()} */}

        <div className="Aadhar-format-2">
          <span>
            <p className="Aadhar-format-read-more">
              Attach a readable front & back photo of your Passport in JPEG or
              PNG (Max Size: 2MB)
            </p>
            <span className="passport-row">
              <span className="Aadhar-Front-row">
                <div className="image-container">
                  <img
                    src={VoterIDFront}
                    width={100}
                    height={100}
                    className="aadhar-Front-sample document-image" alt="Sample passport front" />
                  <div className="badge">1</div>
                </div>

                <span className="Aadhar-Label">FRONT</span>
              </span>
              <span className="Aadhar-Front-row mgl-20">
                <div className="image-container">
                  <img
                    src={VoterIDBack}
                    width={100}
                    height={100}
                    className="aadhar-Front-sample document-image" alt="Sample passport back" />
                  <div className="badge">2</div>
                </div>

                <span className="Aadhar-Label">BACK</span>
              </span>
            </span>
          </span>
        </div>
      </div>
    </div>
  );
};
export default SamplePassportPopup;
